import { FC, ReactNode, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quoteBlotterPreferenceStateLoaded } from 'state/blotters/quote/quoteBlotter.action';
import { fromQuoteBlotter } from 'state/selectors';

import { emptyBlotterPreferences } from '../../shared/Blotter/Grid/blotter.model';
import { BlotterPreferencesLoadingErrorModal } from '../blotterPreferencesLoadingErrorModal';

export const PreferencesLoadingErrorModal: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const dispatch = useDispatch();

  const hasLoadingError = useSelector(fromQuoteBlotter.areBlotterPreferencesInError);
  const onContinueAndDefault = useCallback(
    () => dispatch(quoteBlotterPreferenceStateLoaded(emptyBlotterPreferences)),
    [dispatch],
  );

  return (
    <BlotterPreferencesLoadingErrorModal hasLoadingError={hasLoadingError} onContinueAndDefault={onContinueAndDefault}>
      {children}
    </BlotterPreferencesLoadingErrorModal>
  );
};
